import { PROVIDERS } from '@/constants/providers';
import { Sparkles } from 'lucide-react';

export function ProviderChip({ providerKey, comingSoon = false, active = false, size = 'sm' }) {
  const p = PROVIDERS[providerKey];
  if (!p) return null;
  const cls = size === 'md' ? 'px-3 py-1.5 text-sm' : '';
  return (
    <span
      data-testid={`provider-chip-${providerKey}`}
      className={`provider-chip ${p.bg} ${p.text} ${p.border} ${cls} ${comingSoon ? 'opacity-60' : ''}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${active ? 'animate-pulse ' : ''}${p.dot}`} />
      <span>{p.label}</span>
      {comingSoon && <span className="text-[10px] uppercase tracking-wide font-medium ml-1 opacity-80">soon</span>}
      {active && <Sparkles className="h-3 w-3" />}
    </span>
  );
}
